<template>
  <v-container fluid class="inventoryjournal-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Inventory Journal</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Inventory Journal</p>
                        <v-select
                          class="mb-4"
                          :items=journaltype
                          v-model="new_journal.journaltype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the journal type">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=journalsubtype
                          v-model="new_journal.journalsubtype"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Subtype"
                          persistent-hint
                          single-line hint="Please choose the journal subtype">
                        </v-select>
                        <v-menu
                          ref="menu_journaldate"
                          v-model="menu_journaldate"
                          :close-on-content-click="false"
                          :return-value.sync="new_journal.journaldate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_journal.journaldate"
                              label="Journal Date"
                              v-bind="attrs"
                              v-bind:value="new_journal.journaldate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Please choose the journal date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_journal.journaldate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_journaldate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_journaldate.save(new_journal.journaldate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          class="mb-4"
                          v-model="new_journal.journalname"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Journal Name"
                          persistent-hint
                          single-line hint="Enter the journal name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="new_journal.locationid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-textarea
                          v-model="new_journal.journalnote"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                     
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/inventoryjournal/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <p class="text-h5">Items</p>
                      <v-form>
                        <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                              return {text: x.brandname, value: x._id};
                              })"
                            v-model="brandid"
                            v-bind:error="errorindex == 11"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line hint="Brand">
                          </v-select>
                        </v-col>
                        <v-col md="3">
                          <v-select
                            class="mb-4"
                            :items=branditems
                            v-model="add_transaction.itemid"
                            v-bind:error="errorindex == 12"
                            v-on:change="populatePriceField"
                            outlined
                            dense
                            placeholder="Item"
                            persistent-hint
                            single-line hint="Item">
                          </v-select>
                        </v-col>
                        <v-col md="3">
                          <v-select
                            class="mb-4"
                            :items="locations.map(x => {
                              return {text: x.locationname, value: x._id};
                              })"
                            v-model="add_transaction.locationid"
                            v-bind:error="errorindex == 6"
                            outlined
                            dense
                            placeholder="Location"
                            persistent-hint
                            single-line hint="Please choose the location">
                          </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="add_transaction.increaseQty"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Inc"
                            persistent-hint
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line hint="Increase">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="add_transaction.decreaseQty"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Dec"
                            persistent-hint
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line hint="Decrease">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="add_transaction.itemcost"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Cost"
                            persistent-hint
                            single-line hint="Cost">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addTransaction()">
                            Add
                          </v-btn>
                        </v-col>
                        </v-row>
                          <v-data-table
                            :headers="itemHeaders"
                            :items="transactions"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.itemimage="{ item }"> 
                              <v-img
                                v-bind:lazy-src="item.itemimage"
                                min-width=50
                                max-width=100
                                v-bind:src="item.itemimage"
                              ></v-img>
                            </template>
                            <template v-slot:item.locationid="{ item }">
                              <p class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationcode'] : '' }}</p>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <!-- <v-btn icon color="primary" @click="loadTransaction(item)">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn> -->
                              <v-btn icon color="primary" @click="deleteTransaction(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                      </v-form>
                    </v-col>
                  </v-row>
                    <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertInventoryJournal()">
                            Save
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      itemHeaders: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Name', value: 'itemname' },
        { text: 'Location', value: 'locationid' },
        { text: 'Increase', value: 'increaseQty', width: '10%'},
        { text: 'Decrease', value: 'decreaseQty', width: '10%'},
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      transactions: [],
      sheet: false,
      brandid: undefined,
      price: undefined,
      step: 1,
      new_journal: {},
      add_transaction: {},
      menu_journaldate: false,
      journaltype: ['Inventory Journal'],
      journalsubtype: ['Inventory Adjustment', 'Inventory Transfer'],
      branditems: [],
      error: undefined,
      errortag: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('Price', ['prices']),
    ...mapState('Inventory', ['inventory']),
    ...mapState('InventoryJournal', ['isReceiving']),
  },
  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Price', ['getPricesRequest']),
    ...mapActions('Inventory', ['getInventoryRequest']),
    ...mapActions('InventoryJournal', ['getInventoryJournals', 'insertInventoryJournalRequest']),
    checkError(){
      if(!this.new_journal.journaltype){
        this.errortags = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_journal.journalsubtype){
        this.errortags = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_journal.journaldate){
        this.errortags = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_journal.journalname){
        this.errortags = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.new_journal.locationid){
        this.errortags = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    addTransaction(){
      if(this.new_journal.journalsubtype=='Inventory Transfer') this.insertTransactionTransfer();
      else this.insertTransaction();
      this.clearTransaction();
    },
    clearTransaction(){
      this.add_transaction = {};
    },
    async insertInventoryJournal() {
      if(this.transactions.length==0) return;
      let journal = {journal: this.new_journal, transactions: this.transactions}
      await this.insertInventoryJournalRequest(journal);
      router.push('/inventoryjournal/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans)=>trans.id==item.id);
      if(index!=-1) this.transactions.splice(index, 1);
    },
    insertTransaction(){
      this.add_transaction.id = Math.floor(Math.random() * Math.pow(10, 10));
      this.transactions.push(this.add_transaction);
    },
    insertTransactionTransfer(){
      let trans_inc = Object.assign({}, this.add_transaction);
      let trans_dec = Object.assign({}, this.add_transaction, {locationid: this.new_journal.locationid, increaseQty: 0, decreaseQty: trans_inc.increaseQty});
      trans_inc.id = Math.floor(Math.random() * Math.pow(10, 10));
      trans_dec.id = Math.floor(Math.random() * Math.pow(10, 10));
      this.transactions.push(trans_dec);
      this.transactions.push(trans_inc);
    },

    populateItems(brandid){
      let items = this.items.filter(item=>item.brandid == brandid);
      this.branditems = items.map(x => {return {text: x.itemname, value: x._id};})
    },
    populatePriceField(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let item_inventory;
      if(this.inventory.transactions!=null){
        item_inventory = this.inventory.transactions.find(trans=>trans.locationid==this.new_journal.locationid && trans.itemid==itemid);
      }
      let json = {
        itemid: item._id,
        itemimage: item.itemimage,
        itemname: item.itemname,
        itemquantity: 1,
        itemcost: item_inventory!=null ? item_inventory.itemcost : item!=null? item.itemcost : 0,
      }
      this.add_transaction = Object.assign({}, this.add_transaction, json);
    },
  },

  async created () {
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.prices.length==0) await this.getPricesRequest();
    
    if(Object.keys(this.inventory)==0) await this.getInventoryRequest();    
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
